import { render, staticRenderFns } from "./InfoTypesNav.vue?vue&type=template&id=0dd48fee&"
import script from "./InfoTypesNav.vue?vue&type=script&lang=ts&"
export * from "./InfoTypesNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports